import { ProductCategory } from './types';

export function getTranslationForCategory(category: ProductCategory): string {
    const translationMap = {
        [ProductCategory.TOP_PRODUCTS]: 'main.menu.v2.categories.top_products',
        [ProductCategory.CURRENT]: 'main.menu.v2.categories.current',
        [ProductCategory.CARDS]: 'main.menu.v2.categories.cards',
        [ProductCategory.SAVINGS]: 'main.menu.v2.categories.savings',
        [ProductCategory.BUILDING_SOCIETY]: 'main.menu.v2.categories.building_society',
        [ProductCategory.LOANS]: 'main.menu.v2.categories.loans',
        [ProductCategory.SECURITIES]: 'main.menu.v2.categories.securities',
        [ProductCategory.INSURANCE]: 'main.menu.v2.categories.insurance',
        [ProductCategory.PENSION]: 'main.menu.v2.categories.pension',
        [ProductCategory.OTHER]: 'main.menu.v2.categories.other',
    };

    return translationMap[category];
}
